import { createSlice } from '@reduxjs/toolkit'

export const rootSlice = createSlice({
  name: 'serviceregistration',
  initialState: {
      csrfCookie: '',
      csrfCookieName: '',
      firmId: 0,
      loaded: false,
      modalCount: 0,
      loginModal: false,
      uploadProgress: {},
      alertModal: {
        visible: false,
        message: '',
        defaultMessage: 'There was an error processing your request.',
      },      
      isGlobalLoading: false,
      sideBarVisible: false,  
  },
  reducers: {    
    setCsrfCookie: (state, action) => {
      state.csrfCookie = action.payload
    },    
    setCsrfCookieName: (state, action) => {
      state.csrfCookieName = action.payload
    },
    setFirmId: (state, action) => {
      state.firmId = action.payload
    },
    setUploadProgress: (state, action) => {
      state.uploadProgress = {...state.uploadProgress, [action.payload.key]: action.payload.value}
    },
    clearUploadProgress: (state, action) => {
      state.uploadProgress = {}
    },
    setLoaded: (state, action) => {
      state.loaded = action.payload
    },
    showAlertModal: (state, action) => {    
      document.body.style.overflowY = 'hidden'
      if(!state.alertModal.visible){
        state.modalCount += 1
      }      
      state.alertModal.visible = true
      state.alertModal.message = action.payload ? action.payload : state.alertModal.defaultMessage
    },
    hideAlertModal: (state, action) => {    
      if(state.alertModal.visible){
        state.modalCount -= 1
        if(state.modalCount < 1){
          document.body.style.overflowY = ''        
        }
      }
      state.alertModal.visible = false
      state.alertModal.message = ''      
    },
    showLoginModal: (state, action) => {
      document.body.style.overflowY = 'hidden'
      if(!state.loginModal){
        state.modalCount += 1              
      }
      state.loginModal = true
    },
    hideLoginModal: (state, action) => {
      if(state.loginModal){
        state.modalCount -= 1
        if(state.modalCount < 1){
          document.body.style.overflowY = ''        
        }
      }      
      state.loginModal = false
    },
    showGlobalLoading: (state, action) => {
      document.body.style.overflowY = 'hidden'
      if(!state.isGlobalLoading){
        state.modalCount += 1              
      }
      state.isGlobalLoading = true
    },
    hideGlobalLoading: (state, action) => {
      if(state.isGlobalLoading){
        state.modalCount -= 1
        if(state.modalCount < 1){
          document.body.style.overflowY = ''        
        }
      }      
      state.isGlobalLoading = false
    },
    showSideBar: (state, action) => {      
      state.sideBarVisible = true
    },
    hideSideBar: (state, action) => {      
      state.sideBarVisible = false
    },    
  },
})


export const {
  setCsrfCookie,
  setCsrfCookieName,
  setLoaded, 
  showAlertModal, hideAlertModal,  
  showLoginModal, hideLoginModal,
  showGlobalLoading, hideGlobalLoading,  
  showSideBar, hideSideBar,
  setFirmId,
  setUploadProgress,
  clearUploadProgress,
 } = rootSlice.actions

export default rootSlice.reducer
